import { render, staticRenderFns } from "./HLLegalFrame.vue?vue&type=template&id=1c27fd20&scoped=true&"
import script from "./HLLegalFrame.vue?vue&type=script&lang=js&"
export * from "./HLLegalFrame.vue?vue&type=script&lang=js&"
import style0 from "./HLLegalFrame.vue?vue&type=style&index=0&id=1c27fd20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c27fd20",
  null
  
)

export default component.exports